export default __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.b0400063.ttf";